import { BaseModel } from "sjs-base-model";

export default class NotaValoriModel extends BaseModel {
    public readonly key: string = "";
    public readonly value: string = "";

    constructor(data: Partial<NotaValoriModel>) {
        super();

        this.update(data);
    }
}
